var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowerrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5419_7588)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.19727,
    y: 1.6543,
    width: 16.0919,
    height: 16.0919,
    rx: 1.78799,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6615 9.75361C15.6615 12.716 13.26 15.1176 10.2976 15.1176C7.33512 15.1176 4.93359 12.716 4.93359 9.75361C4.93359 6.79117 7.33512 4.38965 10.2976 4.38965C13.26 4.38965 15.6615 6.79117 15.6615 9.75361Z",
    fill: "#F9B200"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5419_7588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2077 11.4434H9.23848C9.07547 11.4445 8.91509 11.4022 8.77382 11.3208C8.63255 11.2395 8.51548 11.122 8.43462 10.9805C8.35338 10.8418 8.31055 10.6841 8.31055 10.5234C8.31055 10.3627 8.35338 10.205 8.43462 10.0664L9.42365 8.37489C9.50522 8.23524 9.62194 8.1194 9.76221 8.03889C9.90247 7.95838 10.0614 7.91602 10.2231 7.91602C10.3848 7.91602 10.5437 7.95838 10.684 8.03889C10.8243 8.1194 10.941 8.23524 11.0225 8.37489L12.0086 10.0664C12.0899 10.205 12.1327 10.3627 12.1327 10.5234C12.1327 10.6841 12.0899 10.8418 12.0086 10.9805C11.928 11.1216 11.8114 11.2388 11.6707 11.3201C11.53 11.4014 11.3702 11.444 11.2077 11.4434ZM10.2231 8.2103C10.1128 8.20931 10.0042 8.23764 9.90838 8.29237C9.81259 8.34711 9.73305 8.4263 9.67789 8.52185L8.6918 10.2148C8.63662 10.3086 8.60752 10.4154 8.60752 10.5242C8.60752 10.6329 8.63662 10.7397 8.6918 10.8335C8.7464 10.9302 8.8259 11.0105 8.92204 11.0661C9.01818 11.1216 9.12745 11.1504 9.23848 11.1495H11.2077C11.319 11.1507 11.4286 11.122 11.525 11.0664C11.6214 11.0109 11.7012 10.9304 11.7559 10.8335C11.811 10.7397 11.8401 10.6329 11.8401 10.5242C11.8401 10.4154 11.811 10.3086 11.7559 10.2148L10.7683 8.52185C10.7132 8.4263 10.6336 8.34711 10.5378 8.29237C10.442 8.23764 10.3334 8.20931 10.2231 8.2103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5191 8.94508C10.4838 8.90098 10.4391 8.86536 10.3882 8.84089C10.3373 8.81642 10.2816 8.80371 10.2251 8.80371C10.1687 8.80371 10.1129 8.81642 10.0621 8.84089C10.0112 8.86536 9.96647 8.90098 9.93123 8.94508C9.89573 8.98979 9.87114 9.04215 9.85941 9.09802C9.84767 9.15388 9.84912 9.21171 9.86363 9.26692L10.0782 10.156C10.0862 10.1878 10.1045 10.216 10.1303 10.2361C10.1562 10.2563 10.188 10.2672 10.2207 10.2672C10.2535 10.2672 10.2853 10.2563 10.3111 10.2361C10.337 10.216 10.3553 10.1878 10.3633 10.156L10.5852 9.26545C10.5997 9.21057 10.6012 9.15309 10.5897 9.0975C10.5783 9.04192 10.5541 8.98975 10.5191 8.94508ZM10.3045 9.19491L10.2251 9.51528L10.1458 9.19491C10.1422 9.18285 10.1417 9.17011 10.1443 9.1578C10.1469 9.1455 10.1524 9.13402 10.1605 9.12437C10.168 9.11433 10.1778 9.10619 10.189 9.10058C10.2002 9.09496 10.2126 9.09204 10.2251 9.09204C10.2377 9.09204 10.2501 9.09496 10.2613 9.10058C10.2725 9.10619 10.2823 9.11433 10.2898 9.12437C10.2979 9.13402 10.3034 9.1455 10.306 9.1578C10.3086 9.17011 10.308 9.18285 10.3045 9.19491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2224 10.8559C10.3441 10.8559 10.4428 10.7572 10.4428 10.6355C10.4428 10.5137 10.3441 10.415 10.2224 10.415C10.1006 10.415 10.002 10.5137 10.002 10.6355C10.002 10.7572 10.1006 10.8559 10.2224 10.8559Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5419_7588",
    x: 0.856276,
    y: 0.760304,
    width: 18.7738,
    height: 18.7738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.446996
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.670495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_7588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_7588",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_7588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.70265,
    height: 4.70265,
    fill: "white",
    transform: "translate(7.87305 7.3291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowerrorIcon);
export default __webpack_public_path__ + "static/media/yellowerrorIcon.4b8359cbf3c5cad514f827768bd47f7c.svg";
export { ForwardRef as ReactComponent };